import { FC, lazy, PropsWithChildren, Suspense } from 'react';

import { OverlayLoader } from 'shared/ui';

const LazyEditPostback = lazy(() => import('./EditPostback'));

export const EditPostback: FC<PropsWithChildren> = (props) => (
	<Suspense fallback={<OverlayLoader />}>
		<LazyEditPostback {...props} />
	</Suspense>
);
